(ns client-portal.client.voice-insights.ces.views
  (:require [shared.core.reactive :as re]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.recharts-components :as recharts.c]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [client-portal.client.voice-insights.ces.data]
            [shared.core.router :as router]
            [client-portal.client.layout :as l]
            [shared.core.util :as util]))

(defn ces-pie-chart [_]
  (let [sessions-query-params- (re/subscribe [:sessions/relevant-query-params-])]
    (fn [{:keys [ces-counts-by-value]}]
      (let [{:keys [inner-data outer-data]} ces-counts-by-value
            no-ces-filters {:by "tags"
                            :condition "exclude"
                            :join "or"
                            :value (mapv (fn [i]
                                           {:name "crew-ces-score"
                                            :value (str i)})
                                         (range 1 8))}]
        [alc/card {:title "Customer Effort Scores"}
         (if (and (not-empty inner-data) (not-empty outer-data))
           [recharts.c/nested-pie-chart
            {:inner-data (mapv (fn [r]
                                 (assoc r :on-double-click
                                          (fn [e {:keys [raw]}]
                                            (let [sorted-vals (some->> (:vals raw)
                                                                       (vec)
                                                                       (filter identity)
                                                                       (sort))]
                                              (router/open-route-based-on-event
                                                e
                                                [:vi/sessions
                                                 nil
                                                 (assoc @sessions-query-params-
                                                   :fd (sessions.d/filters->query-param
                                                         [(if (not-empty sorted-vals)
                                                            {:by "tags"
                                                             :condition "include"
                                                             :join "or"
                                                             :value (some->> (:vals raw)
                                                                             (vec)
                                                                             (filter identity)
                                                                             (sort)
                                                                             (mapv (fn [v]
                                                                                     {:name "crew-ces-score"
                                                                                      :value (str v)})))}
                                                            no-ces-filters)]))])))))
                               inner-data)
             :outer-data (mapv (fn [r]
                                 (assoc r :on-double-click
                                          (fn [e {:keys [raw]}]
                                            (router/open-route-based-on-event
                                              e
                                              [:vi/sessions
                                               nil
                                               (assoc @sessions-query-params-
                                                 :fd (sessions.d/filters->query-param
                                                       [(if (:value raw)
                                                          {:by "tags"
                                                           :condition "include"
                                                           :join "or"
                                                           :value [{:name "crew-ces-score"
                                                                    :value (str (:value raw))}]}
                                                          no-ces-filters)]))]))))
                               outer-data)
             :width 700
             :height 700
             :show-center-label? true
             :show-legend? true
             :tooltip-config {:show-double-click-message? true}}]
           [empty-state/no-chart-data {}])]))))

(defn root [_]
  (let [all-charts-data- (re/subscribe [:vi-ces/charts-data-])]
    (re/create-class
      {:component-did-mount #(re/dispatch [:vi-ces/initialize])
       :reagent-render
       (fn [args]
         [l/logged-in-with-header-nav-vi
          args
          [:div {:style {:display :flex
                         :flex-direction :column
                         :width "100%"
                         :min-height "100%"}}
           (cond
             (util/loading? @all-charts-data-)
             [empty-state/loading-charts-card]

             :else
             [:div {:style {:display :flex
                            :flex-direction :column
                            :gap 16
                            :padding "20px 17px 29px"}}
              [ces-pie-chart @all-charts-data-]])]])})))
